import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { BaseService } from "../base.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-activation",
  templateUrl: "./activation.component.html",
  styleUrls: ["./activation.component.css"],
})
export class ActivationComponent implements OnInit {
  constructor(private service: BaseService, private router: Router,    private toastr: ToastrService
,     private spinner: NgxSpinnerService
    ) {}
  btnDisable = false;
  isLoading = false;

  OTP: number;

  ngOnInit(): void {
    if (localStorage.getItem(environment.localStorageKey)) {
      this.router.navigate(["/activation"]);
    } else {
      this.router.navigate(["/login"], {
        queryParams: { event: "activation" },
      });
    }
  }
  submit() {
    if (this.btnDisable) {
      this.isLoading = true;
      this.service.activation(this.OTP).subscribe((data) => {
        if (data) {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.success(data.message, "Success!", {
              closeButton: true,
            });
            this.router.navigate(["/home"])
          }
        },
        err => {          
          this.isLoading = false;
          this.spinner.hide();
          if (err) {
            this.toastr.error(err.message, "OOPS!"), {
              closeButton: true,
            };
          }
        }

      );
    }
  }
  onOtpChange(event) {
    this.btnDisable = false;
    if (event.length == 6) {
      this.btnDisable = true;
      this.OTP = event;
    }
  }
}
